import { useEffect, useState } from 'react';
import { getSupportContact } from '../services/support.service';

/**
 * The institution's support contact, asked for once per page load and shared
 * by every component that shows it. null until it answers, and when it cannot
 * (an older server, offline): the caller then shows no contact rather than a
 * made-up one — the help page used to show another institution's address.
 */
let pending = null;
export function useSupportContact() {
  const [contact, setContact] = useState(null);
  useEffect(() => {
    let live = true;
    if (!pending) pending = Promise.resolve(getSupportContact()).catch(() => { pending = null; return null; });
    pending.then((c) => { if (live) setContact(c || null); });
    return () => { live = false; };
  }, []);
  return contact;
}

/** Forget the cached answer (tests; a contact saved since). */
export const forgetSupportContact = () => { pending = null; };

export const hasSupportContact = (c) => Boolean(c && (c.email || c.phone));
